import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import {
  Button,
  TextField,
  CardContent,
  CardHeader,
  Box,
  Typography,
  Container,
  FormControl,
  FormLabel,
  Switch,
  IconButton,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import IsolatedStatusModal from "../../components/StatusModal"
import Toast from "../../components/Toast"
import Header from "../../components/Header"

class UpdateCategoryScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: "",
      status: false,
      category_name: "",
      category_image: "",
      toast: {
        open: false,
        message: "",
        severity: "success" 
      }      
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    })
  }
  
  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    })
  }

  componentDidMount() {
     const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getCategoryDetail(this.props.match.params.id)
  }

  getCategoryDetail = async (id) => {
    const { status, message, data } = await API(this, "get", URL_PATH.catagoryDetails(id))
    if (status == "success") {
              if (data.slug !== this.props.match.params.slug) {
    this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
    return;
}
      this.setState({
        id: data.id,
        status: data.status, // Remove the === 1 comparison
        category_name: data.category_name,
        category_image: data.category_image,
      })
    } else {
      this.showToast(message, "error")
    }
  }

  update = async () => {
    const formdata = new FormData(document.getElementById("categoryForm"))
    formdata.append("status", this.state.status ? 1 : 0)
    const headers = {
      "Content-Type": "multipart/form-data",
    }
    console.log(formdata)
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.updateCategory(this.props.match.params.id),
      formdata,
      headers,
    )

    if (status == "success") {
      this.showToast(message, "success")
      setTimeout(() => {
        this.props.history.push(routes.admin.category.root(this.props.hotels[0]?.hotel_slug))
      }, 2000) // Redirect after 2 seconds
    } else {
      this.showToast(message, "error")
    }
  }

 

  handleImageUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      this.setState({ category_image: URL.createObjectURL(file) })
    }
  }

  handleImageDelete = () => {
    this.setState({ category_image: "" })
  }

  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            p: 3,
          }}
        >
         
           <CardHeader
            title={
              <Header title="Update Category" />

            }
           
          />
          <CardContent>
            <form
              id="categoryForm"
              name="categoryForm"
              onSubmit={(e) => {
                e.preventDefault()
                return this.update()
              }}
            >
              <Box mb={3}>
                <TextField
                  fullWidth
                  id="category_name"
                  name="category_name"
                  label="Category Name"
                  value={this.state.category_name}
                  onChange={(e) => this.setState({ category_name: e.target.value })}
                  variant="outlined"
                  required
                />
              </Box>

              <Box mb={3}>
                <FormLabel>Category Image</FormLabel>
                <Box
                  sx={{
                    mt: 1,
                    border: "1px dashed rgba(255, 255, 255, 0.23)",
                    borderRadius: "8px",
                    p: 3,
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="file"
                    id="category_image"
                    name="category_image"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={this.handleImageUpload}
                  />
                  {this.state.category_image ? (
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <img
                        src={this.state.category_image || "/placeholder.svg"}
                        alt="Category"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          margin: "10px 0px",
                        }}
                      />
                      <IconButton onClick={this.handleImageDelete} size="small">
                        <DeleteIcon style={{color:"#BB0A21"}} />
                      </IconButton>
                    </Box>
                  ) : (
                    <label htmlFor="category_image" style={{ cursor: "pointer" }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px dashed rgba(255, 255, 255, 0.23)",
                            borderRadius: "4px",
                            mb: 1,
                          }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7" />
                            <polyline points="17 8 12 3 7 8" />
                            <line x1="12" y1="3" x2="12" y2="15" />
                          </svg>
                        </Box>
                        <Typography>Upload a file</Typography>
                        <Typography variant="caption" color="text.secondary">
                          PNG, JPG, GIF up to 1.0MB
                        </Typography>
                      </Box>
                    </label>
                  )}
                </Box>
              </Box>
              <Box mb={3}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Status</FormLabel>
                  <Switch
                    checked={this.state.status}
                    onChange={(e) => this.setState({ status: e.target.checked })}
                   
                  />
                </FormControl>
              </Box>
              <Box mt={4} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": { bgcolor: "#E6B54E" },
                  }}
                >
                  Update Category
                </Button>
              </Box>
            </form>
          </CardContent>
        </Box>

        {/* Success Modal */}
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={this.handleCloseToast}
      />
      </Container>
    )
  }
}

export default redux(UpdateCategoryScreen)